module.exports = __webpack_public_path__ + "img/comment.c92ad2b4.svg";